import { g as guttersStyles, _ as __spreadArrays } from '../gutters.module-c9c70930.js';
import cn from 'classnames';
import React, { useMemo } from 'react';
import { createClassNames } from '../utils/index.js';

var styles = {"component":"grid__component_1uhhv","top":"grid__top_1uhhv","middle":"grid__middle_1uhhv","bottom":"grid__bottom_1uhhv","left":"grid__left_1uhhv","center":"grid__center_1uhhv","right":"grid__right_1uhhv","around":"grid__around_1uhhv","between":"grid__between_1uhhv"};
require('./index.css');

var Row = function (_a) {
    var _b = _a.tag, Component = _b === void 0 ? 'div' : _b, className = _a.className, _c = _a.gutter, gutter = _c === void 0 ? {
        mobile: {
            s: 16,
        },
        desktop: {
            m: 24,
        },
    } : _c, align = _a.align, _d = _a.justify, justify = _d === void 0 ? 'between' : _d, children = _a.children, dataTestId = _a.dataTestId;
    var classNames = useMemo(function () { return createClassNames({ gutter: gutter }, guttersStyles); }, [gutter]);
    return (React.createElement(Component, { className: cn.apply(void 0, __spreadArrays([guttersStyles.row,
            styles.component,
            align && styles[align],
            styles[justify]], classNames, [className])), "data-test-id": dataTestId }, children));
};

export { Row };
